import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import {
    BaseComponent,
    EquipmentTireConfig,
    FeatureType,
    Grid,
    ModalSize,
    TireVendor,
    TireVendorRoute,
} from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentTireConfigModalComponent } from './equipment-tire-config-modal.component'
import { TireVendorModalComponent } from './tire-vendor-modal.component'
import { TireVendorRouteModalComponent } from './tire-vendor-route-modal.component'

@Component({
    templateUrl: './tire-management.component.html',
    standalone: true,
    imports: [
        FormsModule,
        NgbNav,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavOutlet,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class TireManagementComponent extends BaseComponent {
    activeTab = 1
    vendorGrid: Grid<TireVendor>
    routeGrid: Grid<TireVendorRoute>
    configGrid: Grid<EquipmentTireConfig>

    constructor() {
        super()
        this.vendorGrid = new Grid<TireVendor>(this.services)
            .setupModalEditing(
                this.services.data.tireVendors,
                'Tire Vendor',
                TireVendorModalComponent,
                () => new TireVendor(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [
                item.name,
                item.contactName,
                item.phone,
                item.email,
                item.resolvedContactName,
                item.resolvedPhone,
                item.resolvedEmail,
                item.resolvedLocation,
                item.contactSource,
            ])

        this.routeGrid = new Grid<TireVendorRoute>(this.services, 'county', this)
            .setupModalEditing(
                this.services.data.tireVendorRoutes,
                'Tire Vendor Route',
                TireVendorRouteModalComponent,
                () => {
                    const r = new TireVendorRoute()
                    r.rank = 1
                    r.equipmentClass = 'Equipment'
                    r.county = '*'
                    return r
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [
                item.county,
                item.countyDisplay,
                item.equipmentClass,
                item.tireVendorName,
                item.vendorPhone,
                item.vendorLocation,
            ])

        this.configGrid = new Grid<EquipmentTireConfig>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentTireConfigs,
                'Equipment Tire Config',
                EquipmentTireConfigModalComponent,
                () => {
                    const c = new EquipmentTireConfig()
                    c.side = 'Left'
                    c.axleNumber = 1
                    return c
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [item.equipment, item.tireSize, item.side, item.positionLabel])

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.tireVendors.queryAll(),
                    this.services.data.tireVendorRoutes.queryAll(),
                    this.services.data.equipmentTireConfigs.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.vendorGrid.items = result[0]
                        this.routeGrid.items = result[1]
                        this.configGrid.items = result[2]
                    },
                }),
        )
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.EquipmentTireManagementEdit])
    }
}
